import Axios from 'axios';
import baseUrlInterceptor from '@/lib/axios/baseUrlInterceptor';
import setAxiosDefaultHeaders from '@/lib/axios/headers';
import httpCodeHandlingInterceptor from '@/lib/axios/httpCodeHandlingInterceptor';

const axios = Axios.create();
setAxiosDefaultHeaders(axios);
baseUrlInterceptor(axios);
httpCodeHandlingInterceptor(axios);

export default axios;
